import { skipToken } from '@reduxjs/toolkit/dist/query';
import { DateTime } from 'luxon';
import { useState } from 'react';
import { useUserLogsQuery } from 'services/users';

export interface UserLogsFilterData {
  period: {
    From: number;
    To: number;
  };
  type: string;
}

export function useUserLogs(userId: string) {
  const [filter, setFilter] = useState<UserLogsFilterData | null>(null);

  const { data, isFetching, error } = useUserLogsQuery(
    filter?.type
      ? {
          userId,
          from: DateTime.fromMillis(filter.period.From).toUTC().toISO(),
          to: DateTime.fromMillis(filter.period.To).toUTC().toISO(),
          event: filter.type
        }
      : skipToken
  );

  return {
    logs: data?.Items || [],
    usernames: data?.Usernames || {},
    setFilter,
    error,
    loading: isFetching
  };
}
